import React, { useState } from "react";
import Image from "../../../elements/Image";
import Modal from "../../../elements/Modal";
import DatePicker from "../../../form/DatePicker";
import TimePicker from "../../../form/timePicker/TimePicker";
import Button from "../../../form/Button";
import {
  addTimeToDate,
  initialsValue,
  parseTimeString,
} from "../../../../helpers";
import Checkbox from "../../../form/Checkbox";
import Indentification from "../../../elements/Indentification";
import { classNames } from "../../../../helpers/classNames";
import { useMutation } from "@tanstack/react-query";
import {
  organizationFollow,
  organizationUnfollow,
} from "../../../../services/followService";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const ArtistItem = ({
  artist,
  index,
  getResponse = () => {},
  variant = "one",
}) => {
  const [open, setOpen] = useState(false);
  const { session } = useSelector((state) => state?.authProvider);

  const { mutate: manageFollowHandler, isPending } = useMutation({
    mutationFn: async (val) => {
      const payload = {
        referenceType: "user",
        toId: artist?.userData?._id,
        fromId: session?.user?._id,
      };
      if (artist?.user !== session?.user?._id) {
        if (artist?.isFollowing) {
          const res = await organizationUnfollow(payload);
          return res;
        } else {
          const res = await organizationFollow(payload);
          return res;
        }
      }
    },
    onSuccess: (res) => {
      getResponse(res);
      if (res?.status === 200) {
        // toast.success(res?.message);
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
  });

  return (
    <>
      {variant === "one" && (
        <div
          onClick={() => setOpen(true)}
          className="border border-surface-04 rounded-xl overflow-hidden relative bg-white cursor-pointer"
        >
          <div className="overflow-hidden h-48">
            <Indentification
              image={artist?.info?.avatarUrl}
              initial={initialsValue(artist?.info?.displayName)}
              alt={artist?.info?.displayName}
              size="full"
              className={"h-full rounded-none"}
              initialStyle={{ fontSize: 50 }}
            />
          </div>
          <div className="p-4">
            <div className="space-y-3">
              <div className="space-y-2">
                <h3 className="font-semibold text-lg leading-tight">
                  {artist?.info?.displayName}
                </h3>
                {/* <p className="text-muted-foreground text-sm">Pop &amp; Rock</p> */}
              </div>
              {/* <div className="flex justify-between items-center">
            <div className="flex items-center gap-1">
              <i className="fa-solid fa-star text-amber-400"></i>
              <span className="font-medium text-sm mt-1">4.3</span>
            </div>
          </div> */}
              <div className="line-clamp-3 text-sm font-medium text-surface-05">
                {artist?.info?.profileData}
              </div>
            </div>
            {artist?.user !== session?.user?._id && (
              <Button
                buttonLabel={
                  !artist?.isFollowing
                    ? isPending
                      ? "Following..."
                      : "Follow"
                    : isPending
                    ? "Unfollowing..."
                    : "Unfollow"
                }
                buttonIcon={
                  !artist?.isFollowing
                    ? "fa-light fa-user-plus"
                    : "fa-light fa-user-minus"
                }
                buttonIconClass={"text-deep-purple"}
                buttonClasses={"w-full bg-transparent border-deep-purple mt-6"}
                buttonLabelClasses={"text-deep-purple"}
                buttonFunction={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  manageFollowHandler();
                }}
                {...(isPending && {
                  loading: true,
                  buttonIconPosition: "left",
                  isDisable: true,
                })}
              />
            )}
          </div>
          {/* {artist?.isFollowing && (
            <div className="absolute left-3 top-3 z-[4]">
              <div className="px-3 py-1 bg-green-500 text-white rounded-full text-xs font-medium flex items-center gap-1">
                <i className="fa-solid fa-check"></i>
                Following
              </div>
            </div>
          )} */}
        </div>
      )}
      {variant === "two" && (
        <div className="space-y-2" onClick={() => setOpen(true)}>
          <div className="overflow-hidden aspect-square w-24 h-24 rounded-full bg-slate-50 border border-slate-100 hover:[&>div]:scale-[1.1] [&>div]:transition-all [&>div]:duration-300  cursor-pointer">
            <Indentification
              image={artist?.info?.avatarUrl}
              initial={initialsValue(artist?.info?.displayName)}
              alt={artist?.info?.displayName}
              // className={"object-cover h-full w-full object-center"}
              size="3xl"
              initialStyle={{ fontSize: 30 }}
            />
          </div>
          <div className="text-sm font-medium text-surface-05 text-center">
            {artist?.info?.displayName}
          </div>
        </div>
      )}
      <Modal
        isOpen={open}
        setIsOpen={() => {
          setOpen(false);
        }}
        size="xl"
      >
        <div className="grid grid-cols-12 gap-2">
          <div className="col-span-3">
            <Indentification
              image={artist?.info?.avatarUrl}
              initial={initialsValue(artist?.info?.displayName)}
              alt={artist?.info?.displayName}
              size="2xl"
              initialStyle={{ fontSize: 30 }}
            />
          </div>
          <div className="col-span-9">
            <div className="space-y-2">
              <h3 className="font-semibold text-lg leading-tight">
                {artist?.info?.displayName}
              </h3>
              {/* <p className="text-muted-foreground text-sm">Pop &amp; Rock</p> */}
            </div>
            <div className="line-clamp-3 text-sm font-medium text-surface-05">
              {artist?.info?.profileData}
            </div>
            {artist?.user !== session?.user?._id && (
              <Button
                buttonLabel={
                  !artist?.isFollowing
                    ? isPending
                      ? "Following..."
                      : "Follow"
                    : isPending
                    ? "Unfollowing..."
                    : "Unfollow"
                }
                buttonIcon={
                  !artist?.isFollowing
                    ? "fa-light fa-user-plus"
                    : "fa-light fa-user-minus"
                }
                buttonIconClass={"text-deep-purple"}
                buttonClasses={"w-full bg-transparent border-deep-purple mt-6"}
                buttonLabelClasses={"text-deep-purple"}
                buttonFunction={manageFollowHandler}
                {...(isPending && {
                  loading: true,
                  buttonIconPosition: "left",
                  isDisable: true,
                })}
              />
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ArtistItem;
